import React, { useState, useEffect } from "react";
import "./profile.css";
import clinicService from "../../Services/clinicService";
import moment from "moment";
import strings from "../../Utils/strings";
import Widgets from "../../Widgets";
import { t } from "../../Utils/translate";
import toast from "react-hot-toast";
import authService from "../../Services/authService";

function ViewClinicProfileDetails({ randomRefresher, hospitalDetails,holidayListprev }) {
  const [schedule, setSchedule] = useState(false);
  const [holiday, setHoliday] = useState(false);
  const [department, setDepartment] = useState(false);
  const [consultation, setConsultation] = useState(false);
  const [insurance, setInsurance] = useState(false);
  const [certificate, setCertificate] = useState(false);
  const [appVersion, setAppVersion] = useState([]);
  const [clinicDetails, setClinicDetails] = useState([]);
  const [clinicUpdateTiming, setClinicUpdateTiming] = useState([]);
  const [clinicDepartment, setClinicDepartment] = useState([]);
  const [clinicInsurance, setClinicInsurane] = useState([]);
  const [clinicLogo, setClinicLogo] = useState(null);
  const [clinicStamp, setClinicStamp] = useState(null);
  const [holidayList, setHolidayList] = useState([]);
  const [audioCall, setAudioCall] = useState(false);
  const [videoCall, setVideoCall] = useState(false);
  const [houseCall, setHouseCall] = useState(false);
  const [remote, setRemote] = useState(false);
  const [countryCode, setCountryCode] = useState(false);
  const [ePrescription, setEPrescription] = useState(false);
  const [medical, setMedical] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setClinicUpdateTiming(hospitalDetails.openingHoursSpecification);
    setClinicDepartment(hospitalDetails.departmentList);
  }, [randomRefresher, hospitalDetails,]);

  const getAllLeaves = async () => {
    let resp
     if (authService.getIsDoctorLogin() === "false") {
      resp = await clinicService.getAllLeaves();
    }
    setHolidayList(resp?.data.leaves);
    
  };
  useEffect(() => {
    getAllLeaves();
    
  },[holidayListprev]);
  
  return (
    <>
      {isLoading ? (
        <Widgets.CircularLoader />
      ) : (
        <div className="view-clinic-profile-details">
          <div className="accordion accordion-flush" id="accordionFlushExample">
            {clinicUpdateTiming && clinicUpdateTiming.length != 0 ? (
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingOne">
                  {schedule ? (
                    <button
                      onClick={() => {
                        setSchedule(!schedule);
                      }}
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                    >
                      {t("labelSchedule")}
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        setSchedule(!schedule);
                      }}
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                    >
                      {t("labelSchedule")}
                    </button>
                  )}
                </h2>
                {schedule ? (
                  <>
                    <div className="accordion-body">
                      {/* <div> */}
                      {clinicUpdateTiming ? (
                        <div>
                          {clinicUpdateTiming &&
                          clinicUpdateTiming.length > 0 ? (
                            <div className="row col-12">
                              {clinicUpdateTiming.map((details) => (
                                <div
                                  className="col days col-md-6 col-sm-6 col-lg-3"
                                  key={details._id}
                                >
                                  <h3 className="week-days">
                                    {/* {details.dayOfWeek} */}
                                    {t(details.dayOfWeek)}
                                  </h3>
                                  <div className="row">
                                    <div className="timing">
                                    {details.opens && details.closes ? (
                                          <div className="col mt-1 text-nowrap">
                                            {moment(details.opens, "HH:mm").format("HH:mm")}
                                            <span className="to mt-1 text-nowrap">
                                              {t("labelTo")}
                                            </span>
                                            {moment(details.closes, "HH:mm").format("HH:mm")}
                                          </div>
                                        ) : (
                                        <div className="col mt-1 text-nowrap">
                                          {t("Closed")}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                      {/* </div> */}
                    </div>
                  </>
                ) : null}
              </div>
            ) : null}
            {holidayList && holidayList.length !== 0 ? (
              <div className="accordion-item mt-2">
                <h2 className="accordion-header" id="flush-headingOne">
                  {holiday ? (
                    <button
                      onClick={() => {
                        setHoliday(!holiday);
                      }}
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                    >
                      {t("labelLeaveSchedule")}
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        setHoliday(!holiday);
                      }}
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                    >
                      {t("labelLeaveSchedule")}
                    </button>
                  )}
                </h2>
                {holiday ? (
                  <div className="accordion-body">
                    {holidayList.map((item, i) => {
                      const formattedDate = moment(
                        item.date,
                        strings.format.appointmentDate
                      ).format(strings.format.appointmentDate);
                      return (
                        <button
                          type="button"
                          className="btn btn-danger me-1 mt-1"
                          key={i}
                        >
                          {formattedDate}
                        </button>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            ) : null}
            {hospitalDetails.bookingConfiguration ? (
              <div className="accordion-item mt-2">
                <h2 className="accordion-header" id="flush-headingOne">
                  {consultation ? (
                    <button
                      onClick={() => {
                        setConsultation(!consultation);
                      }}
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                    >
                      {t("labelConsultation")}
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        setConsultation(!consultation);
                      }}
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                    >
                      {t("labelConsultation")}
                    </button>
                  )}
                </h2>
                {consultation ? (
                  <>
                    <div className="row me-2">
                      {hospitalDetails.bookingConfiguration.videoCall ? (
                        <div className="col-md-4 col-lg-3 text-nowrap me-3">
                          <div>
                            <div className="audio">
                              <div className="accordion-body d-flex consult-call">
                                <i className="ri-live-line me-2 icon"></i>
                                <span className="consultation">
                                  {t("videoConsultation")}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                ) : null}
              </div>
            ) : null}
            {clinicDepartment && clinicDepartment != null ? (
              <div className="accordion-item mt-2">
                <h2 className="accordion-header" id="flush-headingOne">
                  {department ? (
                    <button
                      onClick={() => {
                        setDepartment(!department);
                      }}
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                    >
                      {t("labelSpeciality")}
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        setDepartment(!department);
                      }}
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                    >
                      {t("labelSpeciality")}
                    </button>
                  )}
                </h2>
                {department ? (
                  <div className="accordion-body col-12">
                    {clinicDepartment.map((item, i) => {
                      return (
                        <>
                          {item._id ? (
                            <button
                              type="button"
                              className="btn btn-danger btn-depart text-nowrap me-1 mt-1 col-3"
                            >
                              <span className="company companyFont">
                                {item.departmentName}
                              </span>
                            </button>
                          ) : null}
                        </>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
}

export default ViewClinicProfileDetails;
